module.exports = __webpack_public_path__ + "static/media/patient-records-management-system-healthcare.d6249515.webp";